<script lang="ts">
  import type { PartialNode, SceneNode } from "@shared/common/node/type";
  import { createEventDispatcher, onMount } from "svelte";
  import getShadowRootOrDocument from "../../lib/get-shadow-root-or-document";

  export let node: PartialNode<SceneNode>;

  const id = `nav-button-${node.id}`;
  let active = false;

  const dispatch = createEventDispatcher<{
    click: MouseEvent;
    activeChange: { value: boolean; button: HTMLButtonElement };
  }>();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  type $$Events = {
    click: CustomEvent<MouseEvent>;
    activeChange: CustomEvent<{ value: boolean; button: HTMLButtonElement }>;
  };

  onMount(() => {
    const root = getShadowRootOrDocument(ref);
    const element = root.querySelector(`#node-${node.id}`);

    if (!element) {
      // eslint-disable-next-line no-console
      console.warn("element not found");
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            active = true;
          } else {
            active = false;
          }
        });
      },
      {
        rootMargin: "-50% 0% -50% 0%",
        threshold: 0,
      }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  });

  function handleClick(event: MouseEvent) {
    dispatch("click", event);
  }

  $: dispatch("activeChange", { value: active, button: ref });

  let ref: HTMLButtonElement;
</script>

<button
  {id}
  on:click={handleClick}
  class={["button", active ? "active" : ""].join(" ")}
  bind:this={ref}
>
  <span class="span">
    {node.name}
  </span>
</button>

<style>
  .button {
    display: block;
    width: 100%;
    cursor: pointer;
    white-space: nowrap;
  }

  .span {
    display: block;
    padding: var(--cb-section-group-nav-item-padding);
    font-size: var(--cb-section-group-nav-item-font-size);
    font-family: var(--cb-section-group-nav-item-font-family);
    font-weight: var(--cb-section-group-nav-item-font-weight);
    text-align: center;
    border-bottom: 2px solid transparent;
    color: #a0a0a0;
  }

  .active .span {
    border-bottom-color: #1f1f1f;
    color: #1f1f1f;
  }
</style>
